import WebAPI from './api-calls';

const webApi = new WebAPI();

export async function fetchUtilitiesOverview() {
    const endpoint = '/api/multiutility/utilities-overview';

    const response = await webApi.getFromWebApiWithAccessTokenAsync(endpoint);

    return response.data; 
}